// fetch
import { getWithToken } from './fetch.js';

// urls
import urls from './_services.json';

// util
import { getUrl } from './util.js';

/**
 * getS3Token
 * @param {*} bizCode 0生图，模版工具，专业工具，1社区，2训练
 */
export async function getS3Token(bizCode) {
  const url = getUrl(urls.getS3Token + `/${bizCode}`);

  // get
  return await getWithToken(url);
}

/**
 * imageReview
 * @param {*} imageUrl
 * @param {*} type
 * @returns
 */
export async function imageReview(imageUrl, type) {
  const url = getUrl(urls.imageReview);
  const params = {
    url: imageUrl,
    type: type || 'sd',
  };

  // get
  return await getWithToken(url, params);
}
